import React from 'react';
import { FaPizzaSlice } from 'react-icons/fa';
import { CustomToggle } from '../../../components/CustomToggle';
import { truthy } from '../../../utils/utils';
import { InfoDescription } from '../../../components/InfoDescription';
import {
  ContainerLoja,
  ContentLoja,
  SettingsCard,
  CardHeader,
  ToggleRow,
} from './styles';

const PizzaSettings = ({ config, change }) => {
  return (
    <ContainerLoja>
      <ContentLoja>
        <SettingsCard>
          <CardHeader>
            <FaPizzaSlice />
            <h3>Regras de Cobrança (Pizzas)</h3>
          </CardHeader>
          <ToggleRow>
            <InfoDescription
              label=" Cobrar pelo Sabor Mais Caro (Meio a Meio)"
              description="Em pizzas com mais de um sabor, o sistema ignora a média
                proporcional e cobra o valor integral baseando-se no sabor de
                maior preço."
            />
            <CustomToggle
              id="cobrarMaior"
              checked={truthy(config.cobrarMaior)}
              onChange={() =>
                change('cobrarMaior', Number(!truthy(config.cobrarMaior)))
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Selecionar Tamanho Antes dos Sabores"
              description="O cliente deve escolher o tamanho da pizza primeiro. Os sabores disponíveis só aparecem após a seleção do tamanho."
            />
            <CustomToggle
              id="selectPizzaSizeFirst"
              checked={!!config.selectPizzaSizeFirst}
              onChange={() =>
                change('selectPizzaSizeFirst', !config.selectPizzaSizeFirst)
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Exigir Seleção de Borda"
              description="O cliente é obrigado a escolher uma borda antes de adicionar a pizza ao carrinho, quando houver bordas disponíveis para o grupo."
            />
            <CustomToggle
              id="requirePizzaBorder"
              checked={!!config.requirePizzaBorder}
              onChange={() =>
                change('requirePizzaBorder', !config.requirePizzaBorder)
              }
            />
          </ToggleRow>
        </SettingsCard>
      </ContentLoja>
    </ContainerLoja>
  );
};

export default PizzaSettings;
